var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-component vs-images",class:[`vs-images-hover-${_vm.hover}`, {'alternating': _vm.alternating, 'notBorderRadius': _vm.notBorderRadius, 'notMargin': _vm.notMargin}]},[_c('ul',{staticClass:"vs-ul-images vs-images--ul"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }